'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _adminTrend = require('./admin-trend.component');

var _adminTrend2 = _interopRequireDefault(_adminTrend);

var _adminTrend3 = require('./admin-trend.service');

var _adminTrend4 = _interopRequireDefault(_adminTrend3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.adminTrend', [_angularUiRouter2.default]).component('administrationTrend', _adminTrend2.default).service('AdminTrendService', _adminTrend4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('administrationTrend', {
    parent: 'reports',
    url: '/administrations-trend',
    component: 'administrationTrend',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/admin-trend/admin-trend.module.js